<div class="header_component">
  <div class="status">{{status}}</div>

  <div class="left_Side">
    <div class="left_side_opacity">

    </div>
    <span style="margin-left: 0px !important;" class="back_arrow" (click)="goBack()" *ngIf="showBackButton"><img 
        src="../../assets/images/back_arrow_image.svg" alt=""></span>
    <span style=" margin-left: 0px !important;  width: 20px !important;" class="back_arrow" (click)="goBack()" *ngIf="showBackButtonBlack"><img src="../../assets/images/prev_arr.svg"
        alt=""></span>
    <span *ngIf="!headerTitle"></span><span *ngIf="headerTitle" class="header-title">{{headerTitle}}</span>
    <span *ngIf="showPageRoute" class="route_div">
      <span class="learn">
        Learning Centre >
      </span>
      <span class="currentPage">
        History
      </span>

      <span class="adminAnalyticsPage">
        Admin Analytics
      </span>
    </span>
  </div>

  <div class="right_Side">
    <div class="right_side_opacity">

    </div>

    <div class="linear_border"></div>
    <div [routerLink]="'/profile-page'" class="right_container s-btn s-btn-default">

      <!-- <div class="searchInput"><input type="text" placeholder="Search" name="search"><img class="flaticon-loupe"
          src="../../assets/images/searcgImg.svg" alt="">
      </div>
      <div class="icons"><img src="../../assets/images/bell_ring.svg" alt="">
        <img src="../../assets/images/moon-solid 1.svg"
          alt=""> -->

      <div [routerLink]="'/profile-page'" *ngIf="!user?.userPic" class="profile"><img
          src="../../assets/images/user (1).png" alt="" class="profile_image"></div>
      <div [routerLink]="'/profile-page'" *ngIf="user?.userPic" class="profile"><img [src]="user?.userPic" alt=""
          class="profile_image">
        </div>
        <div class="user_name_box">
			<!-- <span class="welcome">Welcome</span> -->
			<span class="name_userr"> {{ firstName }}</span></div>
      </div>

      <!-- <div class="profile"><img src="../../assets/images/profile_image.svg" alt="" class="profile_image"></div> -->

    </div>
  </div>

  <!-- <div class="headerComponent">
  <div class="leftSpacing"></div>
  <div class="rightSpacing">

    <div class="iconsBar">
      <div class="dropdownContainer">
        <div>
          <div>
            <div class="desc">
              <div class="img"></div>
              <div class="personDetails">
                <span class="welcome">Welcome</span>
                <span class="name">{{ firstName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>   -->